export enum ENDPOINTS {
  customerCode = "UserXpAccount",
  faturas = "account/bills",
  login = "account/login",
  user = "account/me",
}
